import * as UserPreferenceSettingConstants from './UserPreferenceSettingConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    showUserPreferenceModal: false,
    preferenceData: null
}

export default function UserPreferenceSettingReducer(state = initialState, action) {

    switch (action.type) {

        case UserPreferenceSettingConstants.SET_SHOW_USER_PREFERENCE_MODAL:
            return assign({}, state, {
                showUserPreferenceModal: action.newState.showUserPreferenceModal
            });
            break;

        case UserPreferenceSettingConstants.SET_USER_PREFERENCE_DATA:
            return assign({}, state, {
                preferenceData: action.newState.preferenceData
            });
            break;


        default:
            return state;

    }

}